/**
 * @generated SignedSource<<c2c716a7797d9a059c8b95939e0d77b9>>
 * @relayHash adc73b9c1253142f5ef8cb9f6818aa5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f507009c4ed6301683b3bda837b1afe12c22a08d38124b8056f009c724c8dc0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_RichTextPopUpContentQuery } from './ui_RichTextPopUpContentQuery.graphql';

const node: PreloadableConcreteRequest<ui_RichTextPopUpContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5f507009c4ed6301683b3bda837b1afe12c22a08d38124b8056f009c724c8dc0",
    "metadata": {},
    "name": "ui_RichTextPopUpContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
